import { ITlfActionAddReceivedMessage, TlfContextProps } from "./interface";

/**
 * Appends a new SignalR update message when it has not already been recorded.
 *
 * @param state - Current TLF context state.
 * @param action - Add-message action containing the received SignalR payload.
 * @returns Updated state with the new message tracked for duplicate suppression.
 */
export const tlf_addReceivedMessage = (
  state: TlfContextProps,
  action: ITlfActionAddReceivedMessage,
): TlfContextProps => {
  const newState = { ...state };

  if (
    state.receivedMessages.some((message) => message.messageId === action.receivedMessage.messageId)
  ) {
    return newState;
  }

  newState.receivedMessages = [
    ...state.receivedMessages,
    {
      messageId: action.receivedMessage.messageId,
      updatedId: action.receivedMessage.groupName,
      updateTS: new Date(action.receivedMessage.timeStamp),
    },
  ];

  return newState;
};
